// extracted by mini-css-extract-plugin
export default {"button":"Button_button__t+18N","block":"Button_block__vFJF9","primary":"Button_primary__ndDzw","secondary":"Button_secondary__fFvXH"};